import { useFeatureFlagValue } from "@mirage/service-experimentation/useFeatureFlagValue";

const GROWTHBOOK_FEATURE_FLAG_NAME =
  "companyos_2025_03_06_dash_companyos_integration";

export const useCompanyOSIntegrationEnabled = (): boolean => {
  const featureFlagValue = useFeatureFlagValue(GROWTHBOOK_FEATURE_FLAG_NAME);
  return !!featureFlagValue && featureFlagValue !== "OFF";
};

export const useCompanyOSIntegrationVariant = (): string => {
  return useFeatureFlagValue(GROWTHBOOK_FEATURE_FLAG_NAME) as string;
};
